enum Pages {
  DASHBOARD = '/dashboard',
  TRANSACTIONS = '/transactions',
  MY_TAB = '/my-tab',
  EARNINGS = '/earnings',
  SETTINGS = '/settings',
}

const pageTitles: { [key: string]: string } = {
  [Pages.DASHBOARD]: 'Dashboard',
  [Pages.TRANSACTIONS]: 'Transactions',
  [Pages.MY_TAB]: 'My Tab',
  [Pages.EARNINGS]: 'Earnings',
  [Pages.SETTINGS]: 'Settings',
};

export { Pages, pageTitles };
